import axios from 'axios'
import baseUrl from '../config'
import getToken from '../../utils/getToken'

export const generatePaymentIdentifier = (data = {}) => {
  const token = getToken()
  return axios.post(`${baseUrl}/subscriptions/generate-payment-identifier`, { ...data, token })
}

export const confirmSuccessfulPayment = (data = {}) => {
  const token = getToken()
  return axios.post(`${baseUrl}/subscriptions/payment-result-success`, { ...data, token })
}

export const recordFailedPayment = (data = {}) => {
  const token = getToken()
  return axios.post(`${baseUrl}/subscriptions/payment-result-failure`, { ...data, token })
}

export const cancelSubscription = (data = {}) => {
  const token = getToken()
  return axios.post(`${baseUrl}/subscriptions/cancel-subscription`, { ...data, token })
}

export const fetchSubscription = async (data = {}) => {
  const token = getToken()
  const result = await axios.get(`${baseUrl}/subscriptions/fetch-subscription`, {
    params: { ...data, token }
  })

  return result.data
}
